<script>
  import { MaxIcons } from '@/maxduel/assets/icons';

  export default {
    name: 'MaxButton',
    props: {
      loading: Boolean,
      icon: {
        type: String,
        validator(value) {
          return Object.keys(MaxIcons).includes(value);
        },
      },
    },
    computed: {
      iconComponent() {
        return MaxIcons[this.icon];
      },
    },
  };
</script>

<template>
  <button v-bind="$attrs" class="max-button" v-on="$listeners" :disabled="loading">
    <component v-if="icon" :is="iconComponent" />
    <span v-if="loading">Loading...</span>
    <slot v-else />
  </button>
</template>

<style lang="scss" scoped>
  .max-button {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: fit-content;
    color: #fff;
    font-size: 16px;

    padding: 10px 32px;
    font-weight: 600;
    background-color: $md-color-blue;
    border-radius: 6px;

    &[secondary] {
      padding: 10px 16px;
      font-weight: 500;
      background-color: rgba(#fff, 0.1);
      border-radius: 8px;
    }

    &[green] {
      background-color: #0a9a49;
    }

    &[disabled] {
      cursor: not-allowed;
      background: rgba(255, 255, 255, 0.12);
      color: rgba(255, 255, 255, 0.4);
    }

    &[outlined] {
      border: 1px solid rgba(#fff, 0.4);
    }

    &:hover {
      filter: brightness(103%);
    }

    &:active {
      filter: brightness(97%);
    }
  }
</style>
